import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import RenunciaReceitaService from '../../../../../services/renunciaReceita-auth';
import { Link, useParams, Navigate } from 'react-router-dom';
import Moment from 'moment';

const Projeto = () => {
    let { id } = useParams()

    const [nome, setNome] = useState("");
    const [valor, setValor] = useState("");
    const [cnpj, setCnpj] = useState("");
    const [vigencia, setVigencia] = useState("");
    const [setor, setSetor] = useState("");
    const [especie, setEspecie] = useState("");
    const [produto, setProduto] = useState("");
    const [contrapartida, setContrapartida] = useState("");
    const [impacto, setImpacto] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    async function fetchProjeto(id) {
        const response = await RenunciaReceitaService.renunciaReceitaEdit(id);
        setNome(response.data["nome"]);
        setValor(response.data["valor"]);
        setCnpj(response.data["cnpj"]);
        setVigencia(Moment(response.data["vigencia"]).utc(false).format("yyyy-MM-DD"));
        setSetor(response.data["setor"]);
        setEspecie(response.data["especie"]);
        setProduto(response.data["produto"]);
        setContrapartida(response.data["contrapartida"]);
        setImpacto(response.data["impacto"]);
    }

    useEffect(() => {
        fetchProjeto(id);
    }, [id]);

    const ponto = (campo) => {
        return campo.replace(/,/g, ".");
    }


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const renuncia = await RenunciaReceitaService.editar(id, {
                nome: nome,
                valor: valor,
                cnpj: cnpj,
                vigencia: vigencia,
                setor: setor,
                especie: especie,
                produto: produto,
                contrapartida: contrapartida,
                impacto: impacto
            })
            if (renuncia.data["_id"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }


    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                <Row xs={1} lg={2}>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Nome"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="nome"
                                        value={nome}
                                        onChange={e => setNome(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="cnpj">
                                <FloatingLabel
                                    label="CNPJ"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="cnpj"
                                        value={cnpj}
                                        onChange={e => setCnpj(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="Valor Captado">
                                <FloatingLabel
                                    label="Valor"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="valor"
                                        value={valor}
                                        onChange={e => setValor(ponto(e.target.value))} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="Vigência">
                                <FloatingLabel
                                    label="Vigência"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="vigencia"
                                        value={vigencia}
                                        onChange={e => setVigencia(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="Setor">
                                <FloatingLabel
                                    label="Setor"
                                    className="mb-3"
                                >
                                     <Form.Control
                                        required
                                        type="text"
                                        name="setor"
                                        value={setor}
                                        onChange={e => setSetor(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="especie">
                                <FloatingLabel
                                    label="Espécie do Benefício"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="especie"
                                        value={especie}
                                        onChange={e => setEspecie(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="Produto">
                                <FloatingLabel
                                    label="Produto"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="produto"
                                        value={produto}
                                        onChange={e => setProduto(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="Contrapartida">
                                <FloatingLabel
                                    label="Contrapartida"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="contrapartida"
                                        value={contrapartida}
                                        onChange={e => setContrapartida(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="Impacto Obtido/Esperado">
                                <FloatingLabel
                                    label="Impacto Obtido/Esperado"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="impacto"
                                        value={impacto}
                                        onChange={e => setImpacto(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>

                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Salvar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/renuncias/renunciareceita/listar'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Renúncia de Receita editada com sucesso!</Alert>
                <Navigate to={'/restrito/renuncias/renunciareceita/listar'} />
            </Fragment>
        )
    }
}

export default Projeto;